/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the request.
 * - EnAttente: sent to the validators, waiting for an answer
 * - Validee: validated as is
 * - ValideeAvecModifications: validated after the validator changed the quote
 * - Refusee: refused, the quote is blocked for good
 * - Invalidee: superseded by a change of the quote by the broker
 * - Annulee: withdrawn by the broker while pending
 * 
 * @export
 */
export const Statut = {
    EnAttente: 'EnAttente',
    Validee: 'Validee',
    ValideeAvecModifications: 'ValideeAvecModifications',
    Refusee: 'Refusee',
    Invalidee: 'Invalidee',
    Annulee: 'Annulee'
} as const;
export type Statut = typeof Statut[keyof typeof Statut];


export function instanceOfStatut(value: any): boolean {
    for (const key in Statut) {
        if (Object.prototype.hasOwnProperty.call(Statut, key)) {
            if (Statut[key as keyof typeof Statut] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatutFromJSON(json: any): Statut {
    return StatutFromJSONTyped(json, false);
}

export function StatutFromJSONTyped(json: any, ignoreDiscriminator: boolean): Statut {
    return json as Statut;
}

export function StatutToJSON(value?: Statut | null): any {
    return value as any;
}

export function StatutToJSONTyped(value: any, ignoreDiscriminator: boolean): Statut {
    return value as Statut;
}

